import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import GoBackButton from 'components/button/GoBackButton';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import LoadingCard from 'components/loading/LoadingCard';
import ProductLocation from './ProductLocation';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import fetchResourceById from 'components/hoc/fetchResourceById';
import translate from 'components/hoc/translate';
import { SubmissionError } from 'redux-form';
import { connect } from 'react-redux';
import { fetchProduct } from 'store/actions/products/fetchProducts';
import { updateProductLocation } from 'store/actions/products/updateProducts';

class ProductLocationContainer extends React.Component {
    handleSubmitForm = (values) => {
        const {
            history,
            id,
            dispatchForm,
            translate,
        } = this.props;

        return new Promise((resolve, reject) => {
            dispatchForm({
                onError: (error) => {
                    let formErrors = {
                        _error: false,
                    };

                    if (error.response.message === 'location-not-found') {
                        formErrors.location_address = translate('forms.error.location-not-found');
                        formErrors._error = true;
                    }

                    if (formErrors._error) {
                        reject(new SubmissionError(formErrors));
                    }

                    resolve();
                },
                onSuccess: () => {
                    resolve(history.push(`/products/${ id }/show`));
                },
                id: id,
                values: values,
            });
        });
    }

    render() {
        const {
            data,
            form,
            id,
            resourceFetchFailed,
            resourceFetchLoading,
            translate,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        const breadcrumbs = [
            {
                label: translate('resources.products.title'),
                link: '/products',
            },
            {
                label: data.title,
                link: `/products/${ data.id }/show`,
            },
            {
                label: translate('resources.products.forms.location'),
            },
            {
                label: translate('actions.edit'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.products.pages.location', { title: data.title }) } />

                    <Actions>
                        <GoBackButton url={ `/products/${ id }/show` } />

                        <ListButton url='/products' />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <ProductLocation
                            data={ data }
                            form={ form }
                            handleSubmitForm={ this.handleSubmitForm }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

ProductLocationContainer.defaultProps = {
    form: 'product_location',
};

ProductLocationContainer.propTypes = {
    data: PropTypes.object,
    dispatchForm: PropTypes.func.isRequired,
    form: PropTypes.string,
    history: PropTypes.object,
    id: PropTypes.string,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch,) => {
    return {
        dispatchForm: (values) => {
            dispatch(updateProductLocation(values));
        },
    };
};

const enhance = compose(
    translate,
    connect(
        null,
        mapDispatchToProps,
    ),
    fetchResourceById({
        action: fetchProduct,
        resource: 'products',
    })
);

export default enhance(ProductLocationContainer);



// WEBPACK FOOTER //
// ./src/pages/products/productLocation/ProductLocationContainer.js